import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Custom,
  SubForma,
  Textbox,
  Container,
} from '@app/shared';


@Injectable()
export class DataSourceFormService {

  table = false;

  constructor() { }
  /**
   * Retorna el formualrio de la fuente de datos de las tablas
   *
   * @param {SubForma} form
   * @param {*} optionsOther
   * @param {*} templeteForm
   * @returns {BaseControl<any>[]}
   * @memberof DataSourceFormService
   */
  getFormFountDataTable(form: SubForma, optionsOther: any, templeteForm: any): BaseControl<any>[] {
    let formFields: any[] = [];
    if (form.campos && form.campos.length) {
      form.campos.forEach(element => {
        formFields.push({ value: element.alias, key: element.alias });
      });
    }
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboTypeFount',
        template: templeteForm['ngSelectOnly'],
        label: 'Tipo fuente de datos:',
        placeholder: 'Seleccione el tipo de fuente de datos.',
        options: [
          { value: 'Tabla forma', key: 'TablaForma' },
          { value: 'Tabla maestra', key: 'TablaMaestra' }
        ],
        value: form
          ? form.estilo['fuente']
            ? form.estilo['fuente']['form']
              ? 'TablaForma'
              : form.estilo['fuente']['maestra']
                ? 'TablaMaestra'
                : null
            : null
          : null,
        order: 1,
      }),
      new Custom({
        key: 'cboForm',
        template: templeteForm['ngSelectOnly'],
        label: 'Forma de la tabla:',
        placeholder: 'Seleccione la forma de la tabla de carga de datos.',
        options: optionsOther ? optionsOther['forms'] ? optionsOther['forms'] : [] : [],
        value: form
          ? form.estilo['fuente']
            ? form.estilo['fuente']['form']
              ? form.estilo['fuente']['form']
              : null
            : null
          : null,
        order: 2,
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'cboTypeFount',
            siEs: 'Igual',
            valor: 'TablaForma',
            accion: 'Mostrar'
          }
        ]
      }),
      new Custom({
        key: 'cboFormulario',
        label: 'Cargar información de la tabla:',
        template: templeteForm['ngSelectOnly'],
        placeholder: 'Seleccione la tabla de donde se cargaran los datos',
        options: optionsOther ? optionsOther['formularios'] ? optionsOther['formularios'] : [] : [],
        describe: 'Nota: La columna de la forma actual donde se desea llamar una de las columnas ' +
          'de la fuente de datos debe llevar el mismo alias que dicha columna que se desea cargar.',
        value: form
          ? form.estilo['fuente']
            ? form.estilo['fuente']['formulario']
              ? form.estilo['fuente']['formulario']
              : null
            : null
          : null,
        validations: {
          validators: [Validators.required]
        },
        order: 3,
        condictions: [
          {
            campoDepende: 'cboForm',
            siEs: 'Vacio',
            accion: 'Ocultar'
          }
        ]
      }),
      new Custom({
        key: 'cboMaster',
        template: templeteForm['ngSelectOnly'],
        label: 'Cargar informacion de la maestra:',
        placeholder: 'Seleccione la maestra de donde cargaran los datos.',
        options: optionsOther ? optionsOther['masters'] ? optionsOther['masters'] : [] : [],
        value: form
          ? form.estilo['fuente']
            ? form.estilo['fuente']['maestra']
              ? form.estilo['fuente']['maestra']
              : null
            : null
          : null,
        order: 4,
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'cboTypeFount',
            siEs: 'Igual',
            valor: 'TablaMaestra',
            accion: 'Mostrar'
          }
        ]
      }),
      new Custom({
        key: 'cboStructureMaster',
        template: templeteForm['ngSelectMultipleMaster'],
        label: 'Campos de la maestra:',
        placeholder: 'Seleccione los campos de la estructura de la maestra a consultar.',
        options: optionsOther ? optionsOther['mastersStructure'] ? optionsOther['mastersStructure'] : [] : [],
        describe: 'Nota: Esta estructura se utiliza en caso que se desee cargar la información solo en un campo' +
          ' de tipo texto, debido a que no se tiene una estructura se debe indicar.\n En caso de seleccionar' +
          ' un campo de tipo texto y selector con filtro, tomara prioridad la estructura del campo selector' +
          ' que la ingresada en este campo.',
        value: form
          ? form.estilo['fuente']
            ? form.estilo['fuente']['estructura']
              ? form.estilo['fuente']['estructura']
              : null
            : null
          : null,
        order: 4,
        condictions: [
          {
            campoDepende: 'cboMaster',
            siEs: 'Vacio',
            accion: 'Ocultar'
          }
        ]
      }),
      new Custom({
        key: 'cboFields',
        label: 'Campo base:',
        template: templeteForm['ngSelectOnly'],
        placeholder: 'Seleccione el campo base para cargar la información de los registros de la maestra',
        options: optionsOther ? optionsOther['fields'] ? optionsOther['fields'] : [] : [],
        value: form
          ? form.estilo['fuente']
            ? form.estilo['fuente']['campos']
              ? form.estilo['fuente']['campos']
              : null
            : null
          : null,
        validations: {
          validators: [Validators.required]
        },
        parameters: {
          multiple: true
        },
        order: 5,
        condictions: [
          {
            campoDepende: 'cboTypeFount',
            siEs: 'Igual',
            valor: 'TablaMaestra',
            accion: 'Mostrar'
          }
        ]
      }),
      new Container({
        class: 'form-row',
        order: 6,
        controls: [
          new Textbox({
            key: 'chModificar',
            type: 'checkbox',
            value: form
              ? form.estilo['fuente']
                ? form.estilo['fuente']['modificar_registros']
                  ? form.estilo['fuente']['modificar_registros']
                  : false
                : false
              : false,
            label: 'Modificar registros',
            size: 'col-3 col-md-3',
            condictions: [
              {
                campoDepende: 'cboTypeFount',
                siEs: 'Vacio',
                accion: 'Ocultar'
              }
            ]
          }),
          new Textbox({
            key: 'chEliminar',
            type: 'checkbox',
            value: form
              ? form.estilo['fuente']
                ? form.estilo['fuente']['eliminar_registros']
                  ? form.estilo['fuente']['eliminar_registros']
                  : false
                : false
              : false,
            label: 'Eliminar registros',
            size: 'col-3 col-md-3',
            condictions: [
              {
                campoDepende: 'cboTypeFount',
                siEs: 'Vacio',
                accion: 'Ocultar'
              }
            ]
          }),
          new Textbox({
            key: 'chFiltrar',
            type: 'checkbox',
            value: form
              ? form.estilo['fuente']
                ? form.estilo['fuente']['filtrar_registros']
                  ? form.estilo['fuente']['filtrar_registros']
                  : false
                : false
              : false,
            label: 'Filtrar registros',
            size: 'col-3 col-md-3',
            condictions: [
              {
                campoDepende: 'cboTypeFount',
                siEs: 'Igual',
                valor: "TablaForma",
                accion: 'Mostrar'
              }
            ]
          }),
        ]
      }),
      new Custom({
        key: 'cboFormColumns',
        template: templeteForm['ngSelectOnly'],
        label: 'Columna:',
        placeholder: 'Seleccione la columna',
        options: formFields ? formFields : null,
        value: form
          ? form.estilo['fuente_filtro'] : null,
        order: 7,
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'chFiltrar',
            siEs: 'Igual',
            valor: true,
            accion: 'Mostrar'
          }
        ]
      }),
      new Custom({
        key: 'cboMasterColumn',
        template: templeteForm['ngSelectOnly'],
        label: 'filtrar información de la maestra:',
        placeholder: 'Seleccione la maestra de donde filtraran los datos.',
        options: optionsOther ? optionsOther['masters'] ? optionsOther['masters'] : [] : [],
        value: form
          ? form.estilo['fuente_filtro_maestra']
          : null,
        order: 8,
        condictions: [
          {
            campoDepende: 'chFiltrar',
            siEs: 'Igual',
            valor: true,
            accion: 'Mostrar'
          },
          {
            campoDepende: 'cboFormColumns',
            siEs: 'Vacio',
            accion: 'Ocultar'
          }
        ]
      }),
      new Custom({
        key: 'cboStructureMasterFiltred',
        template: templeteForm['ngSelectOnly'],
        label: 'Campos de la maestra para filtrar:',
        placeholder: 'Seleccione los campos de la estructura de la maestra a filtrar.',
        options: optionsOther ? optionsOther['masterStructureFilter'] ? optionsOther['masterStructureFilter'] : [] : [],
        value: form
          ? form.estilo['fuente_filtro_maestra_estructura']
          : null,
        order: 9,
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'chFiltrar',
            siEs: 'Igual',
            valor: true,
            accion: 'Mostrar'
          },
          {
            campoDepende: 'cboMasterColumn',
            siEs: 'Vacio',
            accion: 'Ocultar'
          }
        ]
      }),
      new Textbox({
        key: 'cboFiltredValue',
        type: 'text',
        order: 10,
        value: form
          ? form.estilo['filtro_valor']
          : null,
        label: 'Valor a filtar:',
        size: 'col-3 col-md-3',
        condictions: [
          {
            campoDepende: 'cboFormColumns',
            siEs: 'Vacio',
            accion: 'Ocultar'
          },
          {
            campoDepende: 'chFiltrar',
            siEs: 'Igual',
            valor: true,
            accion: 'Mostrar'
          },
        ]
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/data-source/shared/data-source.form.service.ts